import { twoBtnPopupCreator } from './ConfirmPopup/helper';

export const imageLinkRemovedText = 'Links to images are not allowed and will be removed.';

export default ({ onConfirm }) => {
  twoBtnPopupCreator({
    content: {
      main: imageLinkRemovedText,
      iconPath: '/images/x-green.svg',
    },
    btnConfig: { confirm: { text: 'OK' }, dismiss: { text: 'CANCEL' } },
    onConfirm,
    onDismiss: () => {},
  });
};
